import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { Link as Link$1 } from 'react-aria-components';

const buttonBase = "_button-base_ot5gj_1";
const link = "_link_ot5gj_161";
const styles = {
	buttonBase: buttonBase,
	link: link
};

const DOMAIN_WHITELIST = ["zapier.com", "zapier-staging.com", "localhost"];
const isLinkExternal = (href) => {
  if (!href || href.length === 0) {
    return false;
  }
  const matcher = /(^[?#/]|http)|^[^.]+(\/)/;
  let hrefWithProtocol = href;
  if (!matcher.test(href)) {
    hrefWithProtocol = `https://${href}`;
  }
  const baseUrl = "https://zapier.com";
  let url;
  try {
    url = new URL(hrefWithProtocol, baseUrl);
  } catch (_) {
    return true;
  }
  const [topLevelDomain, secondLevelDomain] = url.host.split(":")[0].split(".").reverse();
  const domain = secondLevelDomain ? `${secondLevelDomain}.${topLevelDomain}` : topLevelDomain;
  return !DOMAIN_WHITELIST.includes(domain);
};
const buildRel = (rel, isExternal, noReferrer) => {
  var _a;
  const externalLinkRel = [];
  if (isExternal) {
    externalLinkRel.push("noopener");
  }
  if (isExternal && noReferrer) {
    externalLinkRel.push("noreferrer");
  }
  const propsRel = (_a = rel === null || rel === void 0 ? void 0 : rel.split(/\s+/)) !== null && _a !== void 0 ? _a : [];
  return [.../* @__PURE__ */ new Set([...propsRel, ...externalLinkRel])].join(" ") || void 0;
};
const Link = forwardRef((_a, ref) => {
  var { children, className, href, size = "medium", variant = "link", rel, noReferrer = true } = _a, props = __rest(_a, ["children", "className", "href", "size", "variant", "rel", "noReferrer"]);
  const trimmedHref = href ? href.trim() : href;
  const isExternal = isLinkExternal(trimmedHref);
  const finalRel = buildRel(rel, isExternal, noReferrer);
  const dataAttributes = Object.fromEntries(Object.entries(props).filter(([key]) => key.startsWith("data-")));
  return jsx(Link$1, Object.assign({}, props, { className: clsx(className, styles.buttonBase, variant === "link" && styles.link), href: trimmedHref, ref, rel: finalRel, "data-a11y-ignore": variant === "brand" ? "color-contrast" : void 0, "data-size": size, "data-variant": variant, "data-zds": true }, dataAttributes, { children }));
});

export { Link };
//# sourceMappingURL=Link.es.js.map
